import I18n from 'i18n-js';

import en from './en.json';
import ar from './Arabic.json';
import gr from './Greek.json';
import hd from './Hindi.json';
import it from './italian.json';
import kr from './Korean.json';
import sp from './Spanish.json';
import cs from './chinees-simple.json';
import tr from './Chinees-traditional.json';
import fr from './French.json';
import ht from './ht.json';
import vi from './vi.json';
import ur from './ur.json';
import so from './so.json';
import pr from './Portuguese.json';
import fa from './fa.json';
import fl from './Filipino.json';
import pn from './Punjabi.json';
import ru from './Russian.json';
import kh from './Khmer.json';
import arm from './arm.json';
import pl from './pl.json';
import ukr from './ukr.json';
import de from './de.json';
import ja from './ja.json';
import yi from './yi.json';

window.I18n = {};
I18n.defaultLocale = 'en_CA';
I18n.fallbacks = 'en_CA';
I18n.translations = {
  en,
  ar,
  ar_SA: ar,
  en_AU: en,
  en_US: en,
  'en-CA': en,
  fa_IR: fa,
  en_CA: en,
  gr_GR: gr,
  fr_CA: fr,
  hd_IN: hd,
  it_IT: it,
  kr_KR: kr,
  sp_CH: cs,
  es_US: sp,
  tr_CH: tr,
  vi_VI: vi,
  ht_HT: ht,
  ur_UR: ur,
  so_SO: so,
  pt_PT: pr,
  RU_RU: ru,
  ru_RU: ru,
  KH_KH: kh,
  kh_KH: kh,
  FL_FL: fl,
  fl_FL: fl,
  PN_PN: pn,
  pn_PN: pn,
  am_AR: arm,
  pl_PL: pl,
  uk_UA: ukr,
  de_DE: de,
  ja_JP: ja,
  yi_IL: yi
};

// eslint-disable-next-line no-underscore-dangle
export function __(name, params = {}) {
  return I18n.t(name, params);
}

export default I18n;
